import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
export const RuleAttributeIcon = (props) => (<SvgIcon viewBox="0 0 16 16" sx={{ fill: 'transparent' }} {...props}>
    <path d="M2.5 4H13.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 8H6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M2.5 12H7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11.5 10.9087L13.3544 12L12.85 9.96313L14.5 8.60063L12.3344 8.43375L11.5 6.5L10.6656 8.43375L8.5 8.60063L10.15 9.96313L9.64563 12L11.5 10.9087Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </SvgIcon>);
export default RuleAttributeIcon;
